"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Affiliation = exports.AffiliationType = void 0;
var AffiliationType;
(function (AffiliationType) {
    AffiliationType["System"] = "SYSTEM";
    AffiliationType["Site"] = "SITE";
    AffiliationType["Sponsor"] = "SPONSOR";
    AffiliationType["Cro"] = "CRO";
})(AffiliationType = exports.AffiliationType || (exports.AffiliationType = {}));
class Affiliation {
}
exports.Affiliation = Affiliation;
//# sourceMappingURL=affiliation.js.map